import React from 'react'

export default function Servicios() {
  return (
    <section id='servicios' className="services-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 style={{textAlign:'left'}} className="text-3xl md:text-4xl lg:text-5xl font-bold piel2">
          Nuestros Servicios Destacados
          </h1>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-7xl mx-auto fade-in-on-scroll">
          {/* Card 1 */}
          <div className="card bg-base-100 shadow-xl mx-auto w-full">
            <figure className=" ">
              <img
                src="img/2.webp"
                alt="Optimización"
                className="rounded-xl w-full  object-cover" />
            </figure>
            <div className="card-body">
              <h2 className="card-title piel">Análisis Inteligente</h2>
              <p className='piel2'>Utilizamos tecnología de sensores de vanguardia, drones y análisis de datos para evaluar y optimizar la salud y nutrición del cultivo.</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="card bg-base-100 shadow-xl mx-auto w-full">
            <figure className=" ">
              <img
                src="img/6.webp"
                alt="Gestión"
                className="rounded-xl w-full  object-cover" />
            </figure>
            <div className="card-body">
              <h2 className="card-title">Pulverización, fertilización y siembra con drones</h2>
              <p>Utilizamos los drones de última generación para pulverizar, fertilizar o sembrar según sus necesidades.</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="card bg-base-100 shadow-xl mx-auto w-full">
            <figure className=" ">
              <img
                src="img/7.webp"
                alt="Seguridad"
                className="rounded-xl w-full  object-cover" />
            </figure>
            <div className="card-body">
              <h2 className="card-title">Sistemas de Riego Automatizados</h2>
              <p>Implementamos soluciones de riego inteligentes que ahorran agua y mejoran la productividad de los cultivos de manera eficiente.</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="card bg-base-100 shadow-xl mx-auto w-full">
            <figure className=" ">
              <img
                src="img/3.webp"
                alt="Conectividad"
                className="rounded-xl w-full  object-cover" />
            </figure>
            <div className="card-body">
              <h2 className="card-title">Monitoreo por Drones</h2>
              <p>Ofrecemos vigilancia aérea con drones para detectar problemas en los cultivos y optimizar la planificación agrícola de manera integral.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
